<template>
  <PersonalSecond v-if="memberType === 'personal'" />
  <EnterpriseSecond v-else />
</template>

<script>
import EnterpriseSecond from './second'
import PersonalSecond from './personal-second'

export default {
  name: 'ApplySecondEntry',
  components: { EnterpriseSecond, PersonalSecond },
  computed: {
    memberType() {
      return this.$store.state.memberType
    }
  },
  created() {
    if (!this.memberType) {
      this.$router.replace('/apply/first')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/join/second-entry.vue